const getOneImageFromSections = (sections) => {
  const fallbackImage = ''
  const t = sections.filter(sec => sec.type === 'picture');
  return t?.[0]?.value || fallbackImage;
}
export default getOneImageFromSections;